module.exports = __webpack_public_path__ + "img/banner_pf.28c91832.png";